var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 3.75A1.25 1.25 0 0014.583 5h3.25a.208.208 0 00.148-.356L13.689.356a.208.208 0 00-.356.144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.333 6.042a.208.208 0 00-.208-.209h-3.542A2.083 2.083 0 0112.5 3.75V.208A.208.208 0 0012.292 0H3.333a1.667 1.667 0 00-1.666 1.667v16.666A1.667 1.667 0 003.333 20h13.334a1.667 1.667 0 001.666-1.667zM7.917 15.938H5.833a.94.94 0 01-.78-1.459l2.054-3.221a.208.208 0 00-.176-.32H5.417a.52.52 0 010-1.042H7.5a.938.938 0 01.78 1.458l-2.053 3.222a.208.208 0 00.175.32h1.515a.52.52 0 010 1.042zm3.23-1.042h.103a.52.52 0 010 1.041H9.583a.52.52 0 010-1.041h.105a.208.208 0 00.208-.208v-3.54a.21.21 0 00-.21-.21h-.103a.52.52 0 010-1.042h1.667a.52.52 0 010 1.041h-.105a.208.208 0 00-.207.208v3.54a.21.21 0 00.21.21zm3.02-1.46h-.52a.21.21 0 00-.21.21v1.77a.52.52 0 11-1.041 0v-5a.52.52 0 01.52-.52h1.25a1.77 1.77 0 010 3.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.167 10.94h-.52a.21.21 0 00-.21.21v1.038a.21.21 0 00.21.21h.52a.73.73 0 000-1.459z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.e3dbfc00.svg";
export { ForwardRef as ReactComponent };